import CardTicket from "../CardTicket/card";
import "./ticketList.css";
import { useState, useEffect } from "react";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { Logger } from "../../../../Logger/Logger";
import SearchContent from "../../../../Ui/table/SearchContent";

const TicketList = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState(-1);
  const [searchKey, setSearchKey] = useState("");
  const [isSuperAdmin, setIsSuperAdmin] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [ordering, setOrdering] = useState("");
  const [fullPageData, setFullPageData] = useState(0);
  const [data, setData] = useState([]);
  const cookies = new Cookies();
  const apiKey = cookies.get("UserLogin");
  const isAdmin = cookies.get("adminRole");
  const isSysAdmin = cookies.get("sysAdminRole");
  Logger.debug("checking admin", isAdmin);
  Logger.debug("checking super admin", isSysAdmin);
  // const apiKey =
  //   "eyJhbGciOiJSUzI1NiIsImtpZCI6IjAyYTYxZWZkMmE0NGZjMjE1MTQ4ZDRlZmZjMzRkNmE3YjJhYzI2ZjAiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJhY2NvdW50cy5nb29nbGUuY29tIiwiYXpwIjoiMjM5NjYxNTUwMDExLXNndjdtbW1hbTlnYTRmazY4Y28xYXRramI5bGU1NHQzLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwiYXVkIjoiMjM5NjYxNTUwMDExLXNndjdtbW1hbTlnYTRmazY4Y28xYXRramI5bGU1NHQzLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwic3ViIjoiMTExMDgzMTEzMTY3MjA3NzMwNjc5IiwiaGQiOiJ3aXNodHJlZXRlY2guY29tIiwiZW1haWwiOiJtdWt1bmQua3Vsa2FybmlAd2lzaHRyZWV0ZWNoLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJhdF9oYXNoIjoiRDBYRnpfZUhrNVRnNzROeEJmOWRLUSIsIm5hbWUiOiJNdWt1bmQgS3Vsa2FybmkiLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EvQUVkRlRwN2lMaTl1bk9BVmwweHZQVXl3ei1jaGdBa3BWR0ZIMlVBM3FHMUk9czk2LWMiLCJnaXZlbl9uYW1lIjoiTXVrdW5kIiwiZmFtaWx5X25hbWUiOiJLdWxrYXJuaSIsImxvY2FsZSI6ImVuIiwiaWF0IjoxNjcxODE1ODczLCJleHAiOjE2NzE4MTk0NzMsImp0aSI6Ijk5OWJlM2VhOWZjNTY1OGY5NGZlMWU4N2NlYjIzODg5NGEwZDlmMGMifQ.FuUyhXAjQHVdZXmkI1QdUbu_Lbvf2WbBO6FiQp-X8RdWZlDnxAReVSZUqiQtroaCV2BT3GGPNcXhBCUsI6nc10Ur--aKbXe-gYZNkJ9PNIvj780Y02GsZL1nkyn6YU4MaMv3FRSZLDYJIGDki3L9At4cJUpCRCT8ELu9ZyP4SDnIqRXU7ipT5iTyzbBQztDqcGHqWOUr9khZ--LjUgk4WmmjDW84sij2pha1nVz9Y-exuqvCYw-gyqUkIgrVjpaGeIrM_llFP2smP0xwFF-zWjvKy2MCKGPhruQtG1ZbEdOVgdOsrIMUc5H0sqzgmB7-2DgKl-P29mzvuYoUSI4nmg";

  const queryParams = {
    limit: rowsPerPage,
    page: page + 1,
    search: searchKey,
    ordering: ordering,
  };

  const params = new URLSearchParams(queryParams);

  const getAllTickets = () => {
    if (
      cookies.get("sysAdminRole") === "true" ||
      cookies.get("adminRole") === "true"
    ) {
      axios
        .get(`${BASE_URL}api/ticket/?${params}`, {
          headers: { Authorization: `Bearer ${apiKey}` },
        })
        .then((res) => {
          Logger.debug("Response in ticketlist", res.data.data.results);
          setData(res.data.data.results);
          setFullPageData(res.data.data._metadata.total_count);
        })
        .catch((error) => {
          Logger.error("error in all tickets", error);
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    } else {
      axios
        .get(`${BASE_URL}api/ticket/self_list/?${params}`, {
          headers: { Authorization: `Bearer ${apiKey}` },
        })
        .then((res) => {
          Logger.debug("Response in ticketlist", res.data.data.results);
          setData(res.data.data.results);
          setFullPageData(res.data.data._metadata.total_count);
        })
        .catch((error) => {
          Logger.error("error in self list", error);
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    }
  };

  useEffect(() => {
    getAllTickets();
  }, [searchKey, page, rowsPerPage, ordering]);
  Logger.debug("ordering", fullPageData.total_count);

  return (
    <div className="listcontainer">
      <div className="w-[100%] p-[15px]">

        {/* <TextField
          id="outlined-basic"
          className="w-[100%]"
          inputProps={{
            style: {
              height: "7px",
            },
          }}
          placeholder="Search"
          onChange={(e) => {
            setSearchKey(e.target.value);
          }}
        /> */}
        <SearchContent
          placeholderText="Search"
          onChange={(e) => {
            setSearchKey(e.target.value);
          }}
        />
      </div>
      <hr className="w-[100%]" />
      <div className="aligndiv p-[15px]">
        <div className="listaction"></div>
        <div className="listingdiv">
          {data.length > 0 ? (
            data.map((e, index) => {
              return <CardTicket key={index} data={e}></CardTicket>;
            })
          ) : (
            <div className="flex flex-col justify-center items-center h-[50vh]">
              <h1>No Tickets</h1>
            </div>
          )}
        </div>
        <div className="listpagination"></div>
      </div>
    </div>
  );
};

export default TicketList;
